<div class="story-viewer">
  <div class="story-header">
    <div class="user-info">
      <img [src]="currentUser?.profilePhotoUrl || 'https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c'" 
           alt="Profile Picture" 
           class="profile-picture"
           (error)="$event.target.src = 'https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c'">
      <div class="user-details">
        <span class="username">{{ currentUser?.publicName }}</span>
        <span class="timestamp">{{ formatTimestamp(stories[currentIndex]?.timestamp) }}</span>
      </div>
    </div>
    <button class="close-btn" (click)="close()">×</button>
  </div>

  <div class="progress-container">
    <div class="progress-bar" *ngFor="let story of stories; let i = index">
      <div class="progress-inner" [style.width.%]="i === currentIndex ? progress : (i < currentIndex ? 100 : 0)"></div>
    </div>
  </div>

  <div class="story-content">
    <div class="media-container">
      <div class="background-blur" *ngIf="stories[currentIndex]?.type === 'image'" 
           [style.background-image]="'url(' + stories[currentIndex]?.url + ')'">
      </div>
      <img *ngIf="stories[currentIndex]?.type === 'image'" 
           [src]="stories[currentIndex]?.url" 
           alt="Story Image"
           class="story-media">
      
      <div class="background-blur" *ngIf="stories[currentIndex]?.type === 'video'" 
           [style.background-image]="'url(' + stories[currentIndex]?.thumbnail + ')'">
      </div>
      <video *ngIf="stories[currentIndex]?.type === 'video'"
             #videoPlayer
             [src]="stories[currentIndex]?.url"
             class="story-media"
             (loadedmetadata)="onVideoLoaded($event)"
             (timeupdate)="onVideoTimeUpdate($event)"
             (ended)="nextStory()"
             controls>
      </video>

      <div *ngIf="stories[currentIndex]?.text" 
           class="story-text"
           [style.color]="stories[currentIndex]?.textColor"
           [style.left]="stories[currentIndex]?.textPosition?.x + '%'"
           [style.top]="stories[currentIndex]?.textPosition?.y + '%'">
        {{ stories[currentIndex]?.text }}
      </div>
    </div>

    <div class="nav-button prev" (click)="previousStory()" *ngIf="currentIndex > 0">
      <span>‹</span>
    </div>
    <div class="nav-button next" (click)="nextStory()" *ngIf="currentIndex < stories.length - 1">
      <span>›</span>
    </div>
  </div>
</div>